<span [ngbPopover]="((date | dateFormat: false : 'HH:mm') | async) + ' UTC'"
      [disablePopover]="!date"
      popoverClass="date-popover"
      [triggers]="'hover'"
      container="body"
      class="cursor-default">
  {{ (date | dateFormat: true : 'HH:mm') | async }}
</span>
